import { Component, SecurityContext, inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { LoginUnauthorizedDto } from "src/app/web-api/web-api";

@Component({
    templateUrl: "./tos-popup.component.html",
    styleUrls: ["./tos-popup.component.scss"],
    standalone: false
})
export class TermsOfServicePopupComponent extends CstResponsivePopupComponentBase<
    LoginUnauthorizedDto,
    boolean
> {
    private _fb = inject(FormBuilder);
    private _ds = inject(DomSanitizer);


    public form: FormGroup = null;
    public html: SafeHtml = "";
    public data: LoginUnauthorizedDto;

    public error = false;

    public onInitialised(): void {
        this.form = this._fb.group({
            accept: [false, Validators.requiredTrue]
        })

        this.html = this._ds.sanitize(SecurityContext.HTML, this.data.termsOfUse);
    }

    public get canAccept() {
        return this.form.valid;
    }

    public onAccept() {
        if (!this.canAccept) {
            this.error = true;
            return;
        }

        this.error = false;
        this.close(true);
    }

    public onCancel() {
        this.close(false);
    }
}